var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-line',_vm._b({attrs:{"items":[
    {
      label: _vm.$ucfirst(_vm.$t('journeyProgress.progress')),
      route: {
        name: 'PatientRecordKnowledgeProgress',
        params: { patientId: _vm.patientId },
      },
      disabled: _vm.version < 3
    },
    {
      label: _vm.$ucfirst(_vm.$t('timeline')),
      route: {
        name: 'PatientRecordKnowledgeTimeline',
        params: { patientId: _vm.patientId },
      },
      disabled: _vm.version < 3
    },
    {
      label: _vm.$ucfirst(_vm.$t('knowledge.selection')),
      route: {
        name: 'PatientRecordKnowledgeSelection',
        params: { patientId: _vm.patientId },
      },
    } ]}},'button-line',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }